import { render, staticRenderFns } from "./OperatnPdfViewer.vue?vue&type=template&id=15186330&"
import script from "./OperatnPdfViewer.vue?vue&type=script&lang=ts&"
export * from "./OperatnPdfViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports